<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <div class="text-h5 font-weight-bold mb-2"><v-icon icon="mdi-alert" class="mr-1"
                            color="primary"></v-icon> Nous sommes désolé</div>
                    <p>Une erreur est survenue lors de la validation de votre commande</p>
                    <div>
                        <ul style="list-style-type:none;">
                            <li v-for="error in booking_availability.errors" :key="error">- {{ error }}</li>
                        </ul>
                    </div>
                    <div v-if="booking_availability.need_tarif_update">
                        Malheureusement, entre la sélection de votre parcours et la validation de votre commande, toutes
                        les places à ce tarif ont été réservées. Nous allons mettre à jour les tarifs pour vous en
                        fonction de la disponibilité. Vous serez redirigé vers la page précedente afin que vous
                        puissiez valider votre commande mise à jour.

                    </div>
                    <div class="d-flex justify-center my-3">
                        <SportipsButton v-if="booking_availability.need_tarif_update" @onClick="refresh_tarifs()"
                            chevron icon="mdi-refresh">Mettre
                            à jour les tarifs</SportipsButton>
                        <SportipsButton v-else toPage="Inscriptions" chevronLeft>Retourner à l'étape
                            précedente</SportipsButton>
                        <!-- <router-link class="sm-fullwidth" :to="{ name: 'Inscriptions' }">
                            <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small">
                                <v-icon icon="mdi-arrow-left-bold" class="mr-1"></v-icon> Retourner à l'étape précedente
                            </v-btn>
                        </router-link> -->
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { useBookingStore } from "@/stores/bookingStore";
import { mapStores } from "pinia";
export default {
    props: ['booking_availability'],
    name: 'BookingAvailabilityAlert',
    data() {
        return {
            // Add your component data here
        };
    },
    computed: {
        ...mapStores(useBookingStore),
    },
    methods: {
        refresh_tarifs() {
            if (this.booking_availability.refreshed_tarifs) {
                this.bookingStore.refresh_tarifs(this.booking_availability.refreshed_tarifs);
            }
            this.$router.push({ name: 'Inscriptions' });
        },
        // Add your component methods here
    },
};
</script>

<style scoped>
/* Add your component styles here */
</style>